var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_106766",
    "data-name": "Group 106766",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9445",
    "data-name": "Ellipse 9445",
    fill: "rgba(253,0,0,0.1)",
    stroke: "#ae285d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_106766-2",
    "data-name": "Group 106766",
    transform: "translate(-1652.683 -3642.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49513",
    "data-name": "Path 49513",
    d: "M1658.983,3660.5l6.219-10.627.474.813q.68,1.169,1.361,2.338a.167.167,0,0,1,0,.2c-.6,1.059-1.2,2.123-1.808,3.181-.721,1.255-1.451,2.5-2.177,3.756a.377.377,0,0,0-.042.067c-.077.238-.238.291-.482.288-1.148-.014-2.3,0-3.446,0C1659.065,3660.511,1659.042,3660.508,1658.983,3660.5Z",
    transform: "translate(0)",
    fill: "#ae285d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49514",
    "data-name": "Path 49514",
    d: "M1931.5,3939.635c.711,0,1.4,0,2.081,0,.565,0,1.13.014,1.694.018a.144.144,0,0,1,.142.085q.778,1.342,1.561,2.682c.219.377.434.756.65,1.134.015.026.027.052.048.092-.055,0-.094.006-.134.006q-1.8,0-3.6,0a.184.184,0,0,1-.187-.106c-.559-.968-1.124-1.932-1.685-2.9C1931.88,3940.32,1931.7,3939.986,1931.5,3939.635Z",
    transform: "translate(-266.291 -283.142)",
    fill: "#ae285d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxis);
export default __webpack_public_path__ + "static/media/axis.a86cd638c98dfb97246f315267ceb622.svg";
export { ForwardRef as ReactComponent };